import React, { useEffect, useState } from "react";
import { adminFetch } from "../../api/adminApi";
import { AdminCard, AdminPageHeader } from "./AdminPageHeader";

export default function AdminAudit() {
  const [entries, setEntries] = useState([]);
  const [err, setErr] = useState("");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await adminFetch("/v1/admin/audit?limit=200");
        if (!cancelled) setEntries(data.entries || []);
      } catch (e) {
        if (!cancelled) setErr(e.message);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div>
      <AdminPageHeader
        kicker="History"
        title="Activity log"
        description="A full record of actions taken in the console — article edits, client changes, key rotations, and team activity."
      />

      {err && (
        <div className="mb-6 rounded-xl border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-300">
          {err}
        </div>
      )}

      <AdminCard noPadding className="overflow-hidden">
        <div className="max-h-[min(72vh,720px)] overflow-auto">
          <table className="w-full border-collapse text-left">
            <thead className="sticky top-0 z-10 border-b border-white/[0.08] bg-[#0a0a0a]/95 backdrop-blur-md">
              <tr>
                <th className="px-4 py-3 font-mono-data text-[10px] font-black uppercase tracking-[0.2em] text-slate-500">
                  When
                </th>
                <th className="px-4 py-3 font-mono-data text-[10px] font-black uppercase tracking-[0.2em] text-slate-500">
                  Action
                </th>
                <th className="px-4 py-3 font-mono-data text-[10px] font-black uppercase tracking-[0.2em] text-slate-500">
                  Entity
                </th>
                <th className="px-4 py-3 font-mono-data text-[10px] font-black uppercase tracking-[0.2em] text-slate-500">
                  Actor
                </th>
                <th className="px-4 py-3 font-mono-data text-[10px] font-black uppercase tracking-[0.2em] text-slate-500">
                  Detail
                </th>
              </tr>
            </thead>
            <tbody>
              {entries.map((e) => (
                <tr
                  key={e.id}
                  className="border-t border-white/[0.05] align-top transition-colors hover:bg-white/[0.02]"
                >
                  <td className="whitespace-nowrap px-4 py-3 font-mono-data text-[11px] text-slate-500">
                    {e.created_at}
                  </td>
                  <td className="px-4 py-3 font-mono-data text-[11px] text-[#CCFF00]/90">
                    {e.action}
                  </td>
                  <td className="px-4 py-3 font-mono-data text-[11px] text-slate-300">
                    {e.entity_type}
                    {e.entity_id ? (
                      <span className="mt-0.5 block truncate text-slate-500">
                        {e.entity_id}
                      </span>
                    ) : null}
                  </td>
                  <td className="max-w-[100px] truncate px-4 py-3 font-mono-data text-[11px] text-slate-500">
                    {e.actor_user_id}
                  </td>
                  <td className="max-w-md break-all px-4 py-3 font-mono-data text-[11px] text-slate-500">
                    {e.detail}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </AdminCard>
    </div>
  );
}